import React from 'react';
import CompanySettings from './system-settings/CompanySettings';
import EditorParent from '@/base-components/EditorParent';
import { Context } from '@/App';

const SystemSettingsPage = () => {
    const { translations } = React.useContext(Context);

    return (
        <EditorParent title={translations.systemSettings.title} description={translations.systemSettings.description}>
            <CompanySettings />
        </EditorParent>
    );
};

export default SystemSettingsPage;
